export const ActionTypes = {
  LOADING: "DELETE_OPTION_CRITERIA_LOADING",
  ERROR: "DELETE_OPTION_CRITERIA_ERROR",
  SUCCESS: "DELETE_OPTION_CRITERIA_SUCCESS",
};
